/**
 * Floats a notification bottom right, as the design shows.
 *
 * Storm's `Snackbar` carries no positioning of its own, so rendered inline it lands in the page flow
 * and overlaps whatever it was rendered next to. Shared by the two notifiers on this page so they
 * cannot drift apart, and so a second one cannot land somewhere else by omission.
 */
export const SNACKBAR_POSITION = {
  position: 'fixed' as const,
  right: '24px',
  bottom: '24px',
  zIndex: 1000,
};
